import { render, staticRenderFns } from "./chatgroup.vue?vue&type=template&id=86dc0086&scoped=true&"
import script from "./chatgroup.vue?vue&type=script&lang=js&"
export * from "./chatgroup.vue?vue&type=script&lang=js&"
import style0 from "./chatgroup.vue?vue&type=style&index=0&id=86dc0086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dc0086",
  null
  
)

export default component.exports